export default __webpack_public_path__ + "assets/right-arrow-blue.09bbbc45.svg";